/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import {
    OutputActions
} from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';


export const fetchOutputEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.OUTPUT_SHOW && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, OutputActions.receiveOutput))
);

export const updateOutputEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.OUTPUT_UPDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, OutputActions.updatedOutput))
);

export const deleteOutputEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.OUTPUT_DELETE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, OutputActions.deletedOutput))
);

export const createOutputEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.OUTPUT_CREATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, OutputActions.createdOutput))
);
